var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 3.17578H2.02094C1.88692 3.17578 1.75839 3.23155 1.66363 3.33083C1.56886 3.43011 1.51563 3.56476 1.51562 3.70516V12.7045C1.51563 12.9853 1.6221 13.2546 1.81163 13.4532C2.00116 13.6517 2.25822 13.7633 2.52625 13.7633H13.6431C13.9112 13.7633 14.1682 13.6517 14.3577 13.4532C14.5473 13.2546 14.6538 12.9853 14.6538 12.7045V3.70516C14.6538 3.56476 14.6005 3.43011 14.5057 3.33083C14.411 3.23155 14.2825 3.17578 14.1484 3.17578ZM8.08469 8.81032L3.32022 4.23453H12.8492L8.08469 8.81032ZM6.23461 8.46953L2.52625 12.0302V4.90882L6.23461 8.46953ZM6.98247 9.1875L7.74044 9.91869C7.83367 10.0083 7.95561 10.0581 8.08216 10.0581C8.20871 10.0581 8.33065 10.0083 8.42388 9.91869L9.18185 9.1875L12.8454 12.7045H3.32022L6.98247 9.1875ZM9.93476 8.46953L13.6431 4.90816V12.0309L9.93476 8.46953Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a7ad735ebbf92cd4290a4413ead5ce60.svg";
export { ForwardRef as ReactComponent };